"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_toastify_1 = require("react-toastify");
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const NativeSelect_1 = __importDefault(require("../../common/js/atoms/NativeSelect"));
const ScopeGuard_1 = __importDefault(require("../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const MassiveCompany_1 = __importDefault(require("../stores/MassiveCompany"));
const SuluResellers_1 = __importDefault(require("../stores/SuluResellers"));
class ResellerModal extends react_1.default.Component {
    loading = false;
    selectedResellerId;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            loading: mobx_1.observable,
            selectedResellerId: mobx_1.observable,
            resellerCountryCode: mobx_1.computed,
            resellers: mobx_1.computed,
            resellerOptions: mobx_1.computed,
            onApplyReseller: mobx_1.action.bound,
        });
    }
    get resellerCountryCode() {
        return AuthorizationStore_1.default.country ?? MassiveCompany_1.default.company?.defaultMassiveAddress?.country?.iso ?? null;
    }
    get resellers() {
        if (null === this.resellerCountryCode) {
            return null;
        }
        return SuluResellers_1.default.getResellersForCountryWithExternalId(this.resellerCountryCode);
    }
    get resellerOptions() {
        return (this.resellers?.reduce((options, currentReseller) => {
            return {
                ...options,
                [currentReseller.externalId]: currentReseller.name,
            };
        }, {}) ?? {});
    }
    componentDidMount() {
        if (null === this.resellers && null !== this.resellerCountryCode) {
            this.loading = true;
            SuluResellers_1.default.loadResellers(this.resellerCountryCode).finally(() => (this.loading = false));
        }
    }
    render() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "modal-header znd-modal__header znd-reseller-modal__header" },
                react_1.default.createElement("h3", { className: "znd-modal__title znd-reseller-modal__title" }, (0, translation_1.t)('modal.reseller.title', { channel: AuthorizationStore_1.default.channelId }))),
            react_1.default.createElement("div", { className: "modal-body znd-modal__body znd-reseller-modal__body" },
                react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.COMPANY_UPDATE], fallback: react_1.default.createElement("div", { className: "mb-4", dangerouslySetInnerHTML: {
                            __html: (0, translation_1.t)('modal.reseller.missing_permission_text', {
                                channel: AuthorizationStore_1.default.channelId,
                            }),
                        } }) },
                    react_1.default.createElement("div", { className: "mb-4", dangerouslySetInnerHTML: {
                            __html: (0, translation_1.t)('modal.reseller.text', { channel: AuthorizationStore_1.default.channelId }),
                        } }),
                    react_1.default.createElement(NativeSelect_1.default, { placeholder: (0, translation_1.t)('modal.reseller.placeholder', { channel: AuthorizationStore_1.default.channelId }), value: this.selectedResellerId ?? '', options: this.resellerOptions, onChange: (selectedResellerId) => {
                            this.selectedResellerId = selectedResellerId;
                        }, disabled: this.loading, noOptionPreselected: true }))),
            react_1.default.createElement("div", { className: "modal-footer znd-modal__footer znd-reseller-modal__footer" },
                react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.COMPANY_UPDATE], fallback: react_1.default.createElement(Button_1.default, { className: "znd-reseller-modal__button", variant: ButtonVariant_1.default.secondary, text: (0, translation_1.t)('modal.reseller.missing_permission_action', {
                            channel: AuthorizationStore_1.default.channelId,
                        }), onClick: this.props.onCancel }) },
                    react_1.default.createElement(Button_1.default, { className: "znd-reseller-modal__button", variant: ButtonVariant_1.default.primary, disabled: !this.selectedResellerId || this.loading, loading: this.loading, text: (0, translation_1.t)('modal.reseller.action', { channel: AuthorizationStore_1.default.channelId }), onClick: this.onApplyReseller })))));
    }
    onApplyReseller() {
        if (!this.selectedResellerId) {
            return;
        }
        this.loading = true;
        MassiveCompany_1.default.updateMassiveCompany({
            massiveCompanyPatchRequestBody: {
                resellerId: this.selectedResellerId,
            },
        })
            .then(() => this.props.onDone())
            .catch(() => react_toastify_1.toast.error((0, translation_1.t)('modal.reseller.error', { channel: AuthorizationStore_1.default.channelId })))
            .finally(() => {
            this.loading = false;
        });
    }
}
exports.default = (0, mobx_react_1.observer)(ResellerModal);
